import { fromJS } from 'immutable'
export default fromJS({
  upload: { selectFile: 'Seleziona un documento' },
  form: { name: 'Cognome: ${name} ' },
  shared: {
    components: {
      form: {
        businessPlaceInput: {
          moreNearbyResults: 'Mostra altri negozi nelle vicinanze',
          error: { couldNotFindNearbyResults: 'Impossibile trovare risultati nelle vicinanze di un luogo indicato' },
          noResultsMessage: 'Nessun risultato trovato.',
          chosen: 'Posizione selezionata',
          label: 'Cerca nome o indirizzo',
          choose: 'La preghiamo di selezionare',
          orClickOnMap: '... oppure clicca sulla mappa.',
          currentMarkerSelection: 'Marcatura posta',
          nearby: 'Nelle vicinanze',
        },
      },
    },
  },
  error: { network: 'La connessione al server non può essere stabilita' },
  names: { lastName: 'Cognome', firstName: 'Nome' },
  errors: {
    acceptance: 'Per favore accetta.',
    default: 'La preghiamo di compilare questo campo',
    canNotConnectToServer: 'Il server non può essere raggiunto al momento.',
    iban: 'La preghiamo di indicare un IBAN valido',
    fileTooBig: 'Il file ${name}  è troppo grande per essere caricato',
    uploadBlocked: 'Un documento è stato bloccato o non ha potuto essere elaborato',
    time: 'Inserisci un formato orario valido',
    phone: 'La preghiamo di inserire un numero di telefono valido.',
    date: 'La preghiamo di inserire una data valida',
    fileTooSmall: 'Il file é troppo grande per essere caricato ${name} ',
    currency: 'La preghiamo di inserire un importo valido',
    file: 'La preghiamo di selezionare un file',
    email: 'La preghiamo di inserire un indirizzo e-mail valido.',
    boundaryError: 'Si è verificato un errore',
    inputContainsBinRange: 'Vi pregiamo di non darci il suo numero di carta di credito',
  },
  genders: { female: 'Signora', male: 'Signor' },
  button: { send: 'Invia', delete: 'Rimuovi' },
  address: { city: 'Località', zip: 'NPA', street: 'Via ' },
  confirmation: { backHome: "Torna alla pagina d'inizio" },
  not_found: { title: 'Il modulo non è stato trovato' },
  format: { time: 'HH:MM', date: 'GG.MM.AAAA' },
  loading: { title: 'Carica…' },
})
